var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82739 10.4442C4.54705 8.721 6.25276 7.01181 7.96545 5.3061C8.07009 5.20145 8.09451 5.14564 7.97242 5.02704C7.43525 4.50731 6.90505 3.97362 6.38182 3.43993C6.2423 3.29691 6.14463 3.28645 5.99812 3.43644C4.37264 5.0689 2.74367 6.69787 1.1147 8.32335C0.978663 8.45939 0.940293 8.55357 1.09726 8.70705C1.67978 9.27911 2.24835 9.85814 2.83088 10.4476L2.82739 10.4442Z",
    fill: "#236F5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24072 10.4965C9.13369 10.4965 10.0232 10.4965 10.9161 10.4965C10.9161 8.77681 10.9127 7.05367 10.9092 5.33401C10.4766 5.25727 10.0441 5.30261 9.61157 5.30261C9.15811 5.30261 8.70116 5.25727 8.2477 5.33401C8.2477 7.05716 8.24421 8.77682 8.24072 10.5L8.24072 10.4965Z",
    fill: "#236F5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07525 3.10824C6.07525 2.2362 6.07525 1.36765 6.07873 0.495605C4.35907 0.495605 2.63941 0.495605 0.91626 0.495605C0.91626 1.36765 0.91626 2.2362 0.919748 3.10824C2.63592 3.10824 4.35558 3.10824 6.07176 3.10824L6.07525 3.10824Z",
    fill: "#236F5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2489 3.10824C9.13838 3.10824 10.0244 3.10824 10.9139 3.10824C10.9139 2.2362 10.9139 1.36416 10.9139 0.495605C10.0244 0.495605 9.13489 0.495605 8.2489 0.495605C8.2489 1.36765 8.2489 2.23969 8.2489 3.11173L8.2489 3.10824Z",
    fill: "#236F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLogo);
export default __webpack_public_path__ + "static/media/active-logo.e0eebb34e190db4e77afc4b1b8216ba0.svg";
export { ForwardRef as ReactComponent };